const { BNPL_CANCELLATION_REASON } = require('arbitrip-common/general/constants');

const CONSTANTS = module.exports = {};

// Payment policy (BI: PaymentMode / payment_policy column values)
CONSTANTS.PAYMENT_POLICY_BNPL = 'bnpl';
CONSTANTS.PAYMENT_POLICY_PAY_ON_CREATION = 'pay_on_creation';

// Composed payment_method tokens (base + optional points suffix, or points-only)
CONSTANTS.PM_BASE_ONLINE_PAYMENT = 'online_payment';
CONSTANTS.PM_BASE_PAYMENT_LINK = 'payment_link';
CONSTANTS.PM_SUFFIX_WALLET_POINTS = '_wallet_points';
CONSTANTS.PM_SUFFIX_ELAL_POINTS = '_elal_points';
CONSTANTS.PM_WALLET_POINTS_ONLY = 'wallet_points_only';
CONSTANTS.PM_ELAL_POINTS_ONLY = 'elal_points_only';

// Mapped BI payment_status values
CONSTANTS.PAYMENT_STATUS_BI_PENDING_PAYMENT = 'pending_payment';
CONSTANTS.PAYMENT_STATUS_BI_PAID = 'paid';
CONSTANTS.PAYMENT_STATUS_BI_PARTIALLY_PAID = 'partially_paid';
CONSTANTS.PAYMENT_STATUS_BI_CANCELLED = 'cancelled'; // reserved for schema/enum completeness, never emitted

// refund_status values (note BI's single-'l' spelling of "partialy_refunded")
CONSTANTS.REFUND_STATUS_REFUNDED = 'refunded';
CONSTANTS.REFUND_STATUS_PARTIALLY_REFUNDED = 'partialy_refunded';
CONSTANTS.REFUND_STATUS_PENDING_REFUND = 'pending_refund'; // reserved for enum completeness, never emitted

// operator_id sentinel: system-performed action (e.g. BNPL auto-cancel)
CONSTANTS.OPERATOR_ID_SYSTEM = '-1';

// BNPL charge attempt result marking a successful charge
CONSTANTS.BNPL_ATTEMPT_RESULT_SUCCESS = 'success';

// Default BI cancellation text for any cancel without a mapped BNPL enum reason
CONSTANTS.CANCELLATION_REASON_CUSTOMER = 'customer_cancelled';

// Internal cancellation reason enum -> BI human-readable text
CONSTANTS.CANCELLATION_REASON_TEXT = {
    [BNPL_CANCELLATION_REASON.PAYMENT_FAILED_3X]: 'cancelled after 3 charging failures',
    [BNPL_CANCELLATION_REASON.TRAVELER_REQUEST]: CONSTANTS.CANCELLATION_REASON_CUSTOMER,
    [BNPL_CANCELLATION_REASON.EXPIRED]: 'expired',
};
